/************************************************************************
 ** IBM Confidential
 **
 ** IBM Business Analytics: Rapidly Adaptive Visualization Engine
 **
 ** (C) Copyright IBM Corp. 2024
 **
 ** The source code for this program is not published or otherwise divested of its trade secrets, 
 ** irrespective of what has been deposited with the U.S. Copyright Office.
 ************************************************************************/
// GENERATED
import Enum from './Enum';
//@import Enum (loadtime) // superclass

/**
 * <p>Java class for contextMode. <p>The following schema fragment specifies the expected content contained within this class. <p> <pre> &lt;simpleType name="contextMode"&gt; &lt;restriction base="{http://www.w3.org/2001/XMLSchema}NMTOKEN"&gt; &lt;enumeration value="warnWhenMissing"/&gt; &lt;enumeration value="includeInQuery"/&gt; &lt;enumeration value="infoWhenMissing"/&gt; &lt;/restriction&gt; &lt;/simpleType&gt; </pre>
 */
export default class ContextMode extends Enum{

	enumValue = null;

	/**
	 * issue a warning.
	 */
	static  WARN_WHEN_MISSING = ContextMode.newLiteral("warnWhenMissing");

	/**
	 * context is required in query (project or in filter).
	 */
	static  INCLUDE_IN_QUERY = ContextMode.newLiteral("includeInQuery");

	/**
	 * provide detail information if context is missing in the query.
	 */
	static  INFO_WHEN_MISSING = ContextMode.newLiteral("infoWhenMissing");



	constructor(v) {
		super(v);
		this.enumValue = v;
	}

	static fromValue(v) {
		for (var i = 0; (i < ContextMode.values().length); ++i) {
			if (ContextMode.values()[i].enumValue == v) {
				return ContextMode.values()[i];
			}
		}
		throw new Error(v);
	}

	value() {
		return this.enumValue;
	}

	getResourceId() {
		return (("ContextMode" + "_") + this.value());
	}
}


// WEBPACK FOOTER //
// ./src/generated/ContextMode.js